module.exports = __webpack_public_path__ + "static/media/copyIcon.b3ddfd18.svg";